import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const MegaphoneIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M20.7992 4.40077C21.1294 4.84252 21.044 5.47152 20.603 5.80281C20.1431 6.14834 19.6616 6.50834 19.2003 6.85325L19.199 6.85422L19.1986 6.85453L18.998 7.00449C18.5567 7.33453 17.9318 7.24569 17.6018 6.80431C17.2704 6.36105 17.3595 5.7322 17.8021 5.39992L17.9982 5.2527L17.999 5.25211C18.4608 4.90545 18.9428 4.54357 19.4032 4.19841C19.8437 3.86824 20.4695 3.95989 20.7992 4.40077ZM19.9999 10.6019C19.4476 10.6019 19 11.0496 19 11.6019C19 12.1542 19.4476 12.6019 19.9999 12.6019H22.0001C22.5523 12.6019 23 12.1542 23 11.6019C23 11.0496 22.5523 10.6019 22.0001 10.6019H19.9999ZM17.6011 16.4091C17.2704 16.8535 17.3632 17.4806 17.8073 17.8118C18.2865 18.1691 18.7945 18.5496 19.2828 18.9153L19.4032 19.0055C19.8437 19.3355 20.4676 19.2465 20.7972 18.8056C21.129 18.3618 21.0392 17.7322 20.5958 17.3998C20.1388 17.0572 19.6607 16.6983 19.2025 16.3543L19.0014 16.2033C18.5596 15.8716 17.931 15.9659 17.6011 16.4091ZM3.54545 7.29411C2.14545 7.29411 1 8.40181 1 9.75565V12.2172C1 13.571 2.14545 14.6787 3.54545 14.6787H4.81818V18.9999C4.81818 19.5522 5.2659 19.9999 5.81818 19.9999H6.36364C6.91592 19.9999 7.36364 19.5522 7.36364 18.9999V14.6787H8.63636L13.4981 17.4996C14.1648 17.8864 15 17.4054 15 16.6347V5.33817C15 4.56741 14.1648 4.0864 13.4981 4.47322L8.63636 7.29411H3.54545ZM9.94727 9.39873L12.4545 7.94642V14.0264L9.94727 12.5741L9.33636 12.2172H8.63636H3V9.75565H8.63636H9.33636L9.94727 9.39873ZM16 7.99988C17.2267 8.85787 18 10.1135 18 11.5051C18 12.8967 17.2267 14.1523 16 14.9999V7.99988Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
